import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "@/config/firebase";

export type ContactIntent = "consultation" | "sales" | "support";

export interface ContactRequestInput {
  readonly intent: ContactIntent;
  readonly name: string;
  readonly email: string;
  readonly organization: string;
  readonly message: string;
  readonly user_id: string;
}

export async function createContactRequest(input: ContactRequestInput): Promise<string> {
  const docRef = await addDoc(collection(db, "contact_requests"), {
    intent: input.intent,
    name: input.name,
    email: input.email,
    organization: input.organization,
    message: input.message,
    user_id: input.user_id,
    status: "new",
    source: "web",
    created_at: serverTimestamp(),
  });
  return docRef.id;
}
